var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"c-current-glyph-effects__header",style:(_vm.textStyle)},[_vm._v(" "+_vm._s(_vm.setName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }